import React from 'react';
import { connect } from 'react-redux';
import { getLocalizedText } from '@vp-dst/localization-util';

import {
    fireUploadCTAAddedUpload,
    fireUploadCTARemovedUpload,
    fireUploadCTAClicked,
} from 'utils/Tracking';
import { addUpload, removeUpload } from 'redux/actionCreators';
import { defaultTextStyle } from 'settings/theme';
import ImagesDisplay from 'components/ImagesDisplay';

class Uploader extends React.Component{
    constructor(props){
        super(props);

        this.uploaderCallBack = this.uploaderCallBack.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete(uploadId){
        fireUploadCTARemovedUpload();

        this.props.removeUploadFromStore(uploadId);
    }

    uploaderCallBack(upload){
        fireUploadCTAAddedUpload();
        
        this.props.addUploadToStore(upload.id, `https://uploads.documents.cimpress.io/v1/uploads/${upload.id}/preview?tenant=${window.model.BriefViewModel.TenantForCimpressUploadService}&uploadToken=${upload.token}`);
    }

    render(){
        const {
            uploadRefs,
            isReadOnly,
        } = this.props;

            return(
                <div>
                    {(!isReadOnly || uploadRefs.length > 0) &&
                        <div
                            style={{
                                ...defaultTextStyle,
                                fontSize: '1.3em',
                                fontWeight: 'bold',

                                marginBottom: 10,
                            }}
                            >
                            {getLocalizedText('upload-images')}
                        </div>
                    }
                        <ImagesDisplay
                            uploadRefs={uploadRefs}
                            isReadOnly={isReadOnly}
                            handleDelete={this.handleDelete}
                        />
                    
                    {!isReadOnly &&
                        <button
                            className="textbutton textbutton-skin-secondary"
                            onClick={()=> {
                                fireUploadCTAClicked();
                                var dialog = window.vp.upload.dialogs.imageuploaderbase.getProxy("imageUploader");
                                dialog.imageDataMode = true;
                                dialog.callback = this.uploaderCallBack;
                                dialog.launchDialog();
                            }}
                        >
                            {getLocalizedText('choose-file')}
                        </button>
                    }
                </div>
            );
    }
}

const mapStateToProps = state => {
    return {
        uploadRef: state.uploadRefs
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addUploadToStore: (uploadId, uploadUrl) => {
            dispatch(addUpload(uploadId, uploadUrl));
        },
        removeUploadFromStore: uploadId => {
            dispatch(removeUpload(uploadId));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Uploader);


// WEBPACK FOOTER //
// ./src/components/Uploader.js